import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../store";
import { format, set } from "date-fns";
import { Button, Input, Loading } from "src/components/shared";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { courseStore, userStore } = useStore();

  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState<any>(null);
  const email = JSON.parse(
    localStorage.getItem("registrationUser") || "{}"
  )?.email;
  const [emailExists, setEmailExists] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      if (id) {
        await courseStore.getCohortById(id);
        setSession(courseStore.classDetails);
      }
      if (!userStore?.user) {
        await userStore.getUser();
        await checkEmailExists();
      }
    } catch (error) {
      toast.error("Error loading session data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkEmailExists = async () => {
    const exists = await userStore?.checkEmail(email);
    setEmailExists(exists);
  };

  const close = () => {
    navigate("/class/" + session?.id);
  };

  const formatDate = (date: string) => {
    if (!date) return "";
    const [rawDate] = date?.split("T");
    const [year, month, day] = rawDate?.split("-");

    const pinnedDate = new Date(+year, +month - 1, +day);

    return format(pinnedDate, "dd MMM yyyy").toUpperCase();
  };

  const handleClick = () => {
    navigate("/myclasses?tab=Upcoming");
  };

  const verifyEmail = () => {
    if (emailExists) {
      localStorage.removeItem("registrationUser");
      localStorage.removeItem("registrationStep");
      navigate("/login");
    } else {
      userStore?.sendVerificationCode(email);
      navigate("/verification");
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="w-screen h-screen overflow-y-auto relative">
      <img
        src="/images/blur-bg.png"
        className="absolute top-0 left-0 w-full h-full object-cover z-[-1]"
      />
      <div className="fixed top-5 right-5 sm:right-9 cursor-pointer size-8 sm:size-11">
        <div className="hidden sm:block">
          <Button
            type="pale"
            icon="/images/icons/close-black.svg"
            onClick={close}
            customStyle={{
              borderRadius: "9999px",
              padding: "14px",
            }}
          />
        </div>
        <div className="block sm:hidden">
          <Button
            type="pale"
            icon="/images/icons/close-black.svg"
            onClick={close}
            customStyle={{
              borderRadius: "9999px",
              padding: "8px",
            }}
          />
        </div>
      </div>

      <div className="flex flex-col gap-5 h-full max-w-[1020px] mx-auto sm:justify-center items-center px-5 sm:px-[60px] lg:px-0 pt-10 sm:pt-0">
        <div className="flex flex-col gap-2.5 items-center">
          <img src="/images/icons/ok1.svg" />
          <div className="flex flex-col gap-1 sm:gap-2 items-center">
            <h4 className="text-body-medium font-body-medium-bold sm:text-body-large sm:font-body-large">
              Enrollment Request Sent
            </h4>
            <p className="body-medium text-primary-gray-600 text-center">
              Our team will contact you soon to finalize your enrollment.
              <br />
              {userStore?.user ? (
                <>Looking forward to having you in class!</>
              ) : (
                <>
                  {emailExists ? "Login" : "Verify your Email"} to finish things
                  up?
                </>
              )}
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-2 w-[350px] sm:w-[450px]">
          <div className="px-5 py-4 bg-white opacity-90 border border-opacity-15 rounded-xl">
            <span className="caption-text text-primary-gray-400">
              Course Name
            </span>
            <p className="body-small">{session?.title}</p>
          </div>
          <div className="flex gap-2">
            <div className="w-1/2 px-5 py-4 bg-white opacity-90 border border-opacity-15 rounded-xl">
              <span className="caption-text text-primary-gray-400">
                Start Date
              </span>
              <p className="body-small">{formatDate(session?.start)}</p>
            </div>
            <div className="w-1/2 px-5 py-4 bg-white opacity-90 border border-opacity-15 rounded-xl">
              <span className="caption-text text-primary-gray-400">
                End Date
              </span>
              <p className="body-small">{formatDate(session?.end)}</p>
            </div>
          </div>

          {userStore?.user ? (
            <Button type="primary_dark" text="Okay" onClick={handleClick} />
          ) : (
            <div className="flex flex-col gap-3 p-4 bg-white opacity-90 border border-opacity-15 rounded-xl">
              <div>
                <span className="caption-text text-primary-gray-800">
                  Email Address
                </span>
                <Input value={email} onChange={() => {}} readOnly />
              </div>
              <Button
                type="primary_dark"
                text={emailExists ? "Login" : "Verify Email"}
                onClick={verifyEmail}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
